import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import data from "../../assets/apiRoutes.json";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import TextBox from 'devextreme-react/text-box';
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  Selection,
} from "devextreme-react/data-grid";
import { GetDateTimeStandardFormat } from "../../common/Utils";

const TransactionAppointmentPopup = (props) => {
  const dataBase =
    props.ReceiptReducer.wmTransactionDatabase !== ""
      ? props.ReceiptReducer.wmTransactionDatabase
      : "";
  const [popupState, setPopUpState] = useState(props.visibility);
  const [transactionAppointmentSearchObj, setTransactionAppointmentSearchObj] =
    useState({
      dbName: dataBase,
      Rowid: props.transRowid,
    });
  const [dataItmGrid, setDataItmGrid] = useState({
    transactionnumber:"",
    actualreceivedshippeddatetime:"",
    shipper:"",
    shipperbolnumber:"",
  });
  const [transactionApptObj, setTransactionApptObj] = useState({
    deliveryPickUpPlannedDateTime: "",
    deliveryPickUpArrivedDateTime: "",
    planWareHouse: "",
    planLocation: "",
    planSourceCode: "",
    planSourceHours: "",
    planReference: "",
    planComment: "",
  });
  var accessToken = props.oidc.user.access_token;
  const columns = ["Transaction #", "Recv/ShipDT", "Shipper", "Shipper#"];

  const hideInfo = () => {
    setPopUpState(false);
    props.parentCallback(false);
  };

  useEffect(() => {
    loadTransactionAppointment();
    loadInventoryTransactionData();
  }, []);
  const loadTransactionAppointment = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Transaction.GetTransactionAppointments}`,
        transactionAppointmentSearchObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setTransactionApptObj(res.data);
      });
  };
  const loadInventoryTransactionData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetTransactionData}`,
        transactionAppointmentSearchObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        var transData = res.data;
        setDataItmGrid(transData);
      });
  };
  function dataReshuffeling(data) {
    function formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
    function formatTime(date) {
      var d = new Date(date),
        hours = "" + d.getHours(),
        minutes = "" + d.getMinutes();

      hours = hours % 12 == 0 ? "12" : "" + (hours % 12);
      if (hours.length < 2) hours = "0" + hours;

      return `${hours}:${minutes.length < 2 ? "0" + minutes : minutes} ${d.getHours() < 12 ? "AM" : "PM"
        }`;
    }

    var dlvryPickUpArrvDate = data.deliveryPickUpArrivedDateTime
      ? formatDate(data.deliveryPickUpArrivedDateTime)
      : "";
    var dlvryPickUpArrvTime = data.deliveryPickUpArrivedDateTime
      ? formatTime(data.deliveryPickUpArrivedDateTime)
      : "";

    var dlvryPlanDate = data.deliveryPickUpPlannedDateTime
      ? formatDate(data.deliveryPickUpPlannedDateTime)
      : "";
    var dlvryPlanTime = data.deliveryPickUpPlannedDateTime
      ? formatTime(data.deliveryPickUpPlannedDateTime)
      : "";

    var planResourceTime = data.planSourceHours
      ? formatTime(data.planSourceHours)
      : "";

    return [
      {
        title: "From",
        Col1: dlvryPlanDate,
        Col2: dlvryPlanTime,
      },
      {
        title: "To",
        Col1: dlvryPickUpArrvDate,
        Col2: dlvryPickUpArrvTime,
      },
      {
        title: "WH/Dock",
        Col1: data.planWareHouse ? data.planWareHouse : "",
        Col2: data.planLocation ? data.planLocation : "",
      },
      {
        title: "Resources",
        Col1: data.planSourceCode ? data.planSourceCode : "",
        Col2: planResourceTime,
      },
      {
        title: "Reference",
        Col1: data.planReference ? data.planReference : "",
      },
      {
        title: "Comment",
        Col1: data.planComment ? data.planComment : "",
      },
    ];
  }
  return (
    <Popup
      //visible={props.visibility}
      visible={popupState}
      onHiding={hideInfo}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title="Transaction Appointment"
      //container=".inventory-container"
      container="#root"
      width="80vw"
      height="45vh"
    >

      <div className="popup-content" style={{ maxHeight: '100%' }}>
        {/* Transaction Data */}
        <div className="row">
            <div className="col-md-12">
              <fieldset className="h-100" >
                <legend className="h6">Transaction</legend>
        <div className="row">
          <div className="col-md-3" >
            <TextBox
              label="Transaction #"
              name="transactionnumber"
              value={dataItmGrid.transactionnumber}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Recv/ShipDT"
              name="Recv/ShipDT"
              value={dataItmGrid.actualreceivedshippeddatetime ? GetDateTimeStandardFormat(dataItmGrid.actualreceivedshippeddatetime) : ""}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Shipper"
              name="Shipper"
              value={dataItmGrid.shipper}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Shipper#"
              name="ShipperNumber"
              value={dataItmGrid.shipperbolnumber}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
        </div>
        </fieldset>
        </div>
        </div>
        <div className="row">
        <div className="col-md-12">
        <fieldset className="h-100 topMargin" >
          <legend className="h6">Assignments</legend>
          <div className="row">
            <div className="col-md-3" >
              <TextBox
                label="From"
                name="From"
                value={transactionApptObj.deliveryPickUpPlannedDateTime ? GetDateTimeStandardFormat(transactionApptObj.deliveryPickUpPlannedDateTime) : ""}
                stylingMode='outlined'
                labelMode="static"
                readOnly={true}
              />
            </div>
            <div className="col-md-3">
              <TextBox
                label="Recv/ShipDT"
                name="Recv/ShipDT"
                value={transactionApptObj.deliveryPickUpArrivedDateTime ? GetDateTimeStandardFormat(transactionApptObj.deliveryPickUpArrivedDateTime) : ""}
                stylingMode='outlined'
                labelMode="static"
                readOnly={true}
              />
            </div>
            <div className="col-md-3">
              <TextBox
                label="Warehouse"
                name="Warehouse"
                value={transactionApptObj.planWareHouse}
                stylingMode='outlined'
                labelMode="static"
                readOnly={true}
              />
            </div>
            <div className="col-md-3">
              <TextBox
                label="Dock"
                name="Dock"
                value={transactionApptObj.planLocation}
                stylingMode='outlined'
                labelMode="static"
                readOnly={true}
              />
            </div>

          </div>
          <div className="row">
            <div className="col-md-3 topMargin" >
              <TextBox
                label="Resource"
                name="Resource"
                value={transactionApptObj.planSourceCode}
                stylingMode='outlined'
                labelMode="static"
                readOnly={true}
              />
            </div>
            <div className="col-md-3 topMargin" >
              <TextBox
                label="Resource Time"
                name="ResourceTime"
                value={transactionApptObj.planSourceHours}
                stylingMode='outlined'
                labelMode="static"
                readOnly={true}
              />
            </div>
            <div className="col-md-3 topMargin" >
              <TextBox
                label="Reference"
                name="Reference"
                value={transactionApptObj.planReference}
                stylingMode='outlined'
                labelMode="static"
                readOnly={true}
              />
            </div>
            <div className="col-md-3 topMargin">
              <TextBox
                label="Comment"
                name="Comment"
                value={transactionApptObj.planComment}
                stylingMode='outlined'
                labelMode="static"
                readOnly={true}
              />
            </div>
          </div>
        </fieldset>
        </div></div>
      </div>
    </Popup>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(TransactionAppointmentPopup);
